import { FC } from "react";
import { MdPaid } from "react-icons/md";
import { floatToPriceWithoutSpace } from "../../functions/price_functions";
import "./cashbackEarnPreview.css";

type Props = {
  amount: number;
  loading?: boolean;
  backgroundColor?: string;
};

/**
 * Prévia discreta do cashback a ganhar no pedido.
 */
const CashbackEarnPreview: FC<Props> = ({
  amount,
  loading = false,
  backgroundColor: backColor = "#f6f6fa",
}) => {
  if (!amount || amount <= 0) return null;

  return (
    <div
      className="cashback-earn-preview"
      aria-live="polite"
      style={{ backgroundColor: backColor }}
    >
      <MdPaid size={18} color="#6E7586" />
      <span>
        {loading ? (
          "Atualizando cashback..."
        ) : (
          <>
            Neste pedido você pode ganhar{" "}
            <b>{floatToPriceWithoutSpace(amount)}</b> de cashback
          </>
        )}
      </span>
    </div>
  );
};

export { CashbackEarnPreview };
